import { render, staticRenderFns } from "./MonthlyList.vue?vue&type=template&id=b1da526e&scoped=true&"
import script from "./MonthlyList.vue?vue&type=script&lang=js&"
export * from "./MonthlyList.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyList.vue?vue&type=style&index=0&id=b1da526e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da526e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VContainer,VSimpleTable})
